module.exports = __webpack_public_path__ + "img/env_6.ce45a58f.jpg";